import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import "./../../bindings/bao-number-box";
function ConfigurationItemCustomInvoiceViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.ConfigurationItem = parent;
    self.Refresh = function () {
        var def = $.Deferred();
        def.resolve();
        return def.promise();
    };
    Bao.inherit(ConfigurationItemCustomInvoiceViewModel, ChildTabViewModel);
    ConfigurationItemCustomInvoiceViewModel.prototype.CompleteCheck = function () {
        return true;
    };
}
export default ConfigurationItemCustomInvoiceViewModel;